import { TRACKING_CONSTANTS } from '../model/constants';

const routeMap = [
  {
    pattern: /^\/members-area\/member-profile\/[^/]+/,
    name: TRACKING_CONSTANTS.PLACES.PROFILE_PAGE
  },
  { pattern: /^\/members-area\/messagesnew/, name: TRACKING_CONSTANTS.PLACES.INBOX_PAGE },
  { pattern: /^\/members-area\/my-matches/, name: TRACKING_CONSTANTS.PLACES.MATCHES_PAGE },
  { pattern: /^\/members-area\/my-favorites/, name: TRACKING_CONSTANTS.PLACES.FAVORITES_PAGE },
  { pattern: /^\/members-area\/visitors/, name: TRACKING_CONSTANTS.PLACES.VISITORS_PAGE },
  { pattern: /^\/members-area\/credits/, name: TRACKING_CONSTANTS.PLACES.CREDITS_PAGE },
  {
    pattern: /^\/members-area\/my-profile(?:\/.*)?$/,
    name: TRACKING_CONSTANTS.PLACES.SETTINGS_PAGE
  },
  { pattern: /^\/members-area\/browse-profiles/, name: TRACKING_CONSTANTS.PLACES.PROFILES_PAGE },
  { pattern: /^\/members-area\/match-game/, name: TRACKING_CONSTANTS.PLACES.MATCH_GAME_PAGE },
  {
    pattern: /^\/members-area\/members-pricing/,
    name: TRACKING_CONSTANTS.PLACES.MEMBER_PRICING_PAGE
  },
  { pattern: /^\/members-area\/about-us/, name: TRACKING_CONSTANTS.PLACES.ABOUT_US_PAGE },
  { pattern: /^\/members-area\/FAQ/, name: TRACKING_CONSTANTS.PLACES.FAQ_PAGE },
  { pattern: /^\/members-area\/pricing/, name: TRACKING_CONSTANTS.PLACES.PRICING_PAGE },
  { pattern: /^\/members-area\/contact-us/, name: TRACKING_CONSTANTS.PLACES.CONTACT_US_PAGE },
  {
    pattern: /^\/members-area\/terms-and-conditions/,
    name: TRACKING_CONSTANTS.PLACES.TERMS_AND_CONDITIONS_PAGE
  },
  {
    pattern: /^\/members-area\/anti-human-trafficking-policy/,
    name: TRACKING_CONSTANTS.PLACES.ANTI_HUMAN_TRAFFICKING_POLICY_PAGE
  },
  {
    pattern: /^\/members-area\/non-consensual-participation-policy/,
    name: TRACKING_CONSTANTS.PLACES.NON_CONSENSUAL_PARTICIPATION_POLICY_PAGE
  },
  {
    pattern: /^\/members-area\/privacy-policy/,
    name: TRACKING_CONSTANTS.PLACES.PRIVACY_POLICY_PAGE
  },
  { pattern: /^\/members-area$/, name: TRACKING_CONSTANTS.PLACES.PROFILES_PAGE }
];

export function useRouteName(): string {
  const matchedRoute = routeMap.find((route) => route.pattern.test(window.location.pathname));
  return matchedRoute?.name || '';
}
